/**
 * Translated Contact page body.
 *
 * Mirrors the English CMS HTML for page_id "contact". The
 * #contact-button-placeholder div must stay — EditablePage moves the
 * "Send a message" button into it after render.
 */

const frenchContact = (d) => `
<div class="legal-page container">
  <h1>Nous joindre</h1>
  <p class="intro-text">Des questions ? Nous serions ravis de vous lire ! Que vous cherchiez un recueil ou un air en particulier, que vous ayez besoin d'aide avec une commande ou que vous souhaitiez simplement parler de musique celtique, nous sommes là pour vous aider.</p>

  <section class="contact-section contact-section-tight">
    <h2>Entrer en contact</h2>
    <div class="contact-reach-card">
      <div id="contact-button-placeholder" class="contact-reach-cta"></div>
      <p class="contact-reach-email">Ou écrivez-nous à <a href="mailto:cranfordpub@gmail.com">cranfordpub@gmail.com</a></p>
    </div>
  </section>

  <section class="contact-section">
    <h2>📞 Téléphone et adresse</h2>
    <div class="contact-phone-location">
      <div class="contact-item contact-item-compact">
        <div class="contact-label">Téléphone</div>
        <div class="contact-value"><a href="tel:19029292391">1-902-929-2391</a></div>
        <div class="contact-note-inline">9 h à 18 h (HNA), la plupart des jours</div>
      </div>
      <div class="address-card address-card-flush">
        <div class="address-text">
          <strong>Cranford Publications</strong><br>
          44549 Cabot Trail, RR#1<br>
          Englishtown, Cape Breton Island<br>
          Nouvelle-Écosse, Canada B0C 1H0
        </div>
        <p class="contact-note"><strong>À noter :</strong> nous sommes une entreprise en ligne à domicile, sans magasin physique. Toutes les ventes se font par téléphone ou en ligne.
<br>
Cela dit, si vous visitez le Cap-Breton pendant les mois d'été, Paul habite en face de <a href="https://wildfirepottery.ca/">Wildfire Books and Pottery</a>, sur la piste Cabot. La boutique tient un bon choix des livres de musique et des CD présentés sur ce site, et vous pourriez même y croiser Paul.</p>
      </div>
    </div>
  </section>

  <section class="contact-section">
    <h2>💳 Modes de paiement</h2>
    <div class="info-box">
      <ul class="payment-list">
        <li>💳 Principales cartes de crédit (Visa, MasterCard, American Express)</li>
        <li>🅿️ PayPal</li>
        <li>💵 Mandats (en dollars canadiens ou américains)</li>
        <li>🏦 Chèques certifiés (en dollars canadiens ou américains)</li>
      </ul>
      <p class="info-note"><strong>Devise :</strong> tous les prix sont en dollars canadiens (CAD)</p>
    </div>
  </section>

  <section class="contact-section">
    <h2>🚚 Renseignements sur la livraison</h2>
    <div class="info-box">
      <ul class="shipping-list">
        <li>🇨🇦 <strong>Livraison gratuite au Canada</strong> pour les commandes de plus de 50 $</li>
        <li>🌍 Livraison internationale offerte partout dans le monde</li>
        <li>📦 Les commandes sont généralement expédiées en 2 à 3 jours ouvrables</li>
        <li>📫 Un numéro de suivi est fourni pour chaque envoi</li>
      </ul>
      <p class="info-note">Écrivez-nous pour connaître les tarifs et les délais de livraison à l'international</p>
    </div>
  </section>

  <section class="contact-section">
    <h2>ℹ️ Renseignements sur l'entreprise</h2>
    <div class="business-info-grid">
      <div class="info-item">
        <div class="info-label">Fondée en</div>
        <div class="info-value">1979</div>
        <div class="info-subtext">Plus de 40 ans en activité</div>
      </div>
      <div class="info-item">
        <div class="info-label">Heures d'ouverture</div>
        <div class="info-value">9 h – 18 h</div>
        <div class="info-subtext">Heure normale de l'Atlantique (HNA)</div>
      </div>
      <div class="info-item">
        <div class="info-label">Spécialité</div>
        <div class="info-value">Musique celtique</div>
        <div class="info-subtext">Cap-Breton, Irlande et Écosse</div>
      </div>
      <div class="info-item">
        <div class="info-label">Numéro de TVH</div>
        <div class="info-value">89023 4395 RT0001</div>
        <div class="info-subtext">Numéro d'entreprise canadien</div>
      </div>
    </div>

    <p class="contact-note-center">
      <strong>Nous sommes une petite entreprise familiale !</strong><br>
      Les délais peuvent varier, mais nous nous efforçons de répondre à toutes les demandes en ${d.responseWindow} pendant les jours ouvrables.
    </p>
  </section>
</div>
`;

const germanContact = `
<div class="legal-page container">
  <h1>Kontakt</h1>
  <p class="intro-text">Sie haben Fragen? Wir hören gern von Ihnen! Ob Sie ein bestimmtes Notenbuch oder eine bestimmte Melodie suchen, Hilfe bei einer Bestellung brauchen oder einfach über keltische Musik sprechen möchten — wir helfen Ihnen weiter.</p>

  <section class="contact-section contact-section-tight">
    <h2>Kontakt aufnehmen</h2>
    <div class="contact-reach-card">
      <div id="contact-button-placeholder" class="contact-reach-cta"></div>
      <p class="contact-reach-email">Oder schreiben Sie uns an <a href="mailto:cranfordpub@gmail.com">cranfordpub@gmail.com</a></p>
    </div>
  </section>

  <section class="contact-section">
    <h2>📞 Telefon und Adresse</h2>
    <div class="contact-phone-location">
      <div class="contact-item contact-item-compact">
        <div class="contact-label">Telefon</div>
        <div class="contact-value"><a href="tel:19029292391">1-902-929-2391</a></div>
        <div class="contact-note-inline">9–18 Uhr AST, an den meisten Tagen</div>
      </div>
      <div class="address-card address-card-flush">
        <div class="address-text">
          <strong>Cranford Publications</strong><br>
          44549 Cabot Trail, RR#1<br>
          Englishtown, Cape Breton Island<br>
          Nova Scotia, Kanada B0C 1H0
        </div>
        <p class="contact-note"><strong>Bitte beachten:</strong> Wir sind ein Onlinegeschäft von zu Hause aus, ohne Ladengeschäft. Alle Verkäufe laufen telefonisch oder online.
<br>
Wenn Sie in den Sommermonaten durch Cape Breton reisen: Paul wohnt gegenüber von <a href="https://wildfirepottery.ca/">Wildfire Books and Pottery</a> am Cabot Trail. Das Geschäft führt eine gute Auswahl der Notenbücher und CDs von dieser Website — und vielleicht treffen Sie dort sogar Paul.</p>
      </div>
    </div>
  </section>

  <section class="contact-section">
    <h2>💳 Zahlungsarten</h2>
    <div class="info-box">
      <ul class="payment-list">
        <li>💳 Gängige Kreditkarten (Visa, MasterCard, American Express)</li>
        <li>🅿️ PayPal</li>
        <li>💵 Zahlungsanweisungen (in kanadischen oder US-Dollar)</li>
        <li>🏦 Bestätigte Schecks (in kanadischen oder US-Dollar)</li>
      </ul>
      <p class="info-note"><strong>Währung:</strong> Alle Preise sind in kanadischen Dollar (CAD) angegeben</p>
    </div>
  </section>

  <section class="contact-section">
    <h2>🚚 Versandinformationen</h2>
    <div class="info-box">
      <ul class="shipping-list">
        <li>🇨🇦 <strong>Kostenloser Versand innerhalb Kanadas</strong> ab einem Bestellwert von 50 $</li>
        <li>🌍 Internationaler Versand weltweit möglich</li>
        <li>📦 Bestellungen werden in der Regel innerhalb von 2–3 Werktagen versandt</li>
        <li>📫 Für jede Sendung erhalten Sie eine Sendungsnummer</li>
      </ul>
      <p class="info-note">Schreiben Sie uns für internationale Versandkosten und Lieferzeiten</p>
    </div>
  </section>

  <section class="contact-section">
    <h2>ℹ️ Unternehmensinformationen</h2>
    <div class="business-info-grid">
      <div class="info-item">
        <div class="info-label">Gegründet</div>
        <div class="info-value">1979</div>
        <div class="info-subtext">Über 40 Jahre am Markt</div>
      </div>
      <div class="info-item">
        <div class="info-label">Geschäftszeiten</div>
        <div class="info-value">9–18 Uhr</div>
        <div class="info-subtext">Atlantic Standard Time (AST)</div>
      </div>
      <div class="info-item">
        <div class="info-label">Spezialisierung</div>
        <div class="info-value">Keltische Musik</div>
        <div class="info-subtext">Cape Breton, Irland und Schottland</div>
      </div>
      <div class="info-item">
        <div class="info-label">HST-Nummer</div>
        <div class="info-value">89023 4395 RT0001</div>
        <div class="info-subtext">Kanadische Unternehmensnummer</div>
      </div>
    </div>

    <p class="contact-note-center">
      <strong>Wir sind ein kleiner Familienbetrieb!</strong><br>
      Die Antwortzeiten können schwanken, aber wir bemühen uns, alle Anfragen an Werktagen innerhalb von 24–48 Stunden zu beantworten.
    </p>
  </section>
</div>
`;

export const CONTACT_PAGE_TRANSLATIONS = {
  'fr-CA': {
    title: 'Nous joindre',
    description:
      'Joignez Cranford Publications : cranfordpub@gmail.com ou 1-902-929-2391. Cap-Breton, Nouvelle-Écosse.',
    html: frenchContact({ responseWindow: '24 à 48 heures' }),
  },
  'fr-FR': {
    title: 'Contact',
    description:
      'Contactez Cranford Publications : cranfordpub@gmail.com ou 1-902-929-2391. Cap-Breton, Nouvelle-Écosse.',
    html: frenchContact({ responseWindow: '24 à 48 heures' }),
  },
  de: {
    title: 'Kontakt',
    description:
      'Kontakt zu Cranford Publications: cranfordpub@gmail.com oder 1-902-929-2391. Cape Breton, Nova Scotia.',
    html: germanContact,
  },
};
